import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Checkout from "./pages/Checkout";
import Success from "./pages/Success";
import Help from "./pages/Help";
import HomeCourse from "./pages/HomeCourse";
import CourseDetail from "./pages/CourseDetail";
import Security from "./pages/Security";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Battery from "./pages/Battery";
import Mobile from "./pages/Enhetsbyte";
import DigitalLock from "./pages/DigitalLock";
import DiskUpgrade from "./pages/DiskUpgrade";
import AccessibilityPage from "./pages/AccessibilityPage";
import Booking from "./pages/Booking";
import SecurityBooking from "./pages/SecurityBooking";
import CourseAccess from "./pages/CourseAccess";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/manual/:slug" element={<Layout><Category /></Layout>} />
            <Route path="/kassa/:productId" element={<Layout><Checkout /></Layout>} />
            <Route path="/tack" element={<Layout><Success /></Layout>} />
            <Route path="/hjalp" element={<Layout><Help /></Layout>} />
            <Route path="/om-oss" element={<Layout><About /></Layout>} />
            <Route path="/kontakt" element={<Layout><Contact /></Layout>} />
            <Route path="/batteribyte" element={<Layout><Battery /></Layout>} />
            <Route path="/enhetsbyte" element={<Layout><Mobile /></Layout>} />
            <Route path="/digitala-las" element={<Layout><DigitalLock /></Layout>} />
            <Route path="/uppgradering" element={<Layout><DiskUpgrade /></Layout>} />
            <Route path="/tillganglighet" element={<Layout><AccessibilityPage /></Layout>} />
            <Route path="/boka" element={<Layout><Booking /></Layout>} />
            <Route path="/hemkurs" element={<Layout><HomeCourse /></Layout>} />
            <Route path="/hemkurs/:service" element={<Layout><CourseDetail /></Layout>} />
            <Route path="/sakerhet" element={<Layout><Security /></Layout>} />
            <Route path="/sakerhet/hembesok" element={<Layout><SecurityBooking /></Layout>} />
            <Route path="/tillgang" element={<Layout><CourseAccess /></Layout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/panel" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
